import { State, ReduxAction } from '../../../reducers/reducerType'
import { SyncPlayInType } from './syncPlayInTypes'
import { PlayInObject } from '../../../../lib/playIn/types'
import isEqual from 'lodash/isEqual'
import { playInActions } from '../../../slices/playIn'
import { addEntry } from '../../../../lib/audit'

export const setPlayInInitialStateError = (): ReduxAction => ({ type: SyncPlayInType.SET_PLAY_IN_INITIAL_STATE_ERROR })
export const setPlayInInitialStateSuccess = (): ReduxAction => ({ type: SyncPlayInType.SET_PLAY_IN_INITIAL_STATE_SUCCESS })
export const setSyncPlayInState = (docValues: PlayInObject, initialState = false) => (dispatch, getState: () => State) => {

  if (!docValues && initialState) return dispatch(setPlayInInitialStateError())

  const {
    currentPos,
    currentPosTimestamp,
    endAt,
    pausedAt,
    remoteStatusRequest,
    startAt,
    status,
    sources,
    url, // in case this is set in the document - will translate to sources
    initiatedBy
  } = docValues

  if (currentPos !== getState().playIn.currentPos) {

    dispatch(playInActions.setCurrentPos({ position: currentPos, timestamp: currentPosTimestamp }))

  }

  if (endAt !== getState().playIn.endAt) {

    dispatch(playInActions.setEnd(endAt))

  }

  if (pausedAt !== getState().playIn.pausedAt) {

    dispatch(playInActions.setPaused({ position: pausedAt, timestamp: currentPosTimestamp }))

  }

  if (!isEqual(remoteStatusRequest, getState().playIn.remoteStatusRequest)) {

    dispatch(playInActions.setRemoteStatusRequest(remoteStatusRequest))

  }

  if (startAt !== getState().playIn.startAt) {

    dispatch(playInActions.setStart(startAt))

  }

  if (status !== getState().playIn.status) {

    dispatch(playInActions.setStatus(status))

  }

  if( url && !getState().playIn.sources?.length ){

    dispatch(playInActions.setSources({ sources: [ url ], initiatedBy }))

  }

  if (sources && !isEqual(sources, getState().playIn.sources)){

    addEntry('PresenterService', 'PlayInSetSources', JSON.stringify({
      'sources': sources,
      'by': initiatedBy
    }), 'info')
    dispatch(playInActions.setSources({ sources, initiatedBy }))

  }

  if (initialState) dispatch(setPlayInInitialStateSuccess())

}

export default {
  setPlayInInitialStateError,
  setPlayInInitialStateSuccess,
  setSyncPlayInState
}
